import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './services/auth.service';

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  try {
    return (await auth.initializeSession())
      ? true
      : router.createUrlTree(['/auth/login']);
  } catch {
    return router.createUrlTree(['/auth/login']);
  }
};
